document.addEventListener("DOMContentLoaded", function () {
  if (window.ATTACH_MODULE_INITIALIZED) return;
  window.ATTACH_MODULE_INITIALIZED = true;

  // Named constants for magic numbers
  const MODAL_CLOSE_ANIMATION_MS = 300;
  const NETWORK_TIMEOUT_MS = 10000;
  const TOAST_AUTO_CLOSE_MS = 4000;
  const ERROR_TOAST_POSITION = { top: '20px', right: '20px' };

  let hasExplicitlyAddedToCart = false;
  let modalOpenedWithoutAction = false;
  let isModuleInitialized = false;
  let isModuleClosing = false; // Module-level race condition guard

  // TRACK PDP VARIANT ID CHANGES
  const variantInput = document.querySelector('input[name="id"]');
  if (variantInput) {
    window.PDP_SELECTED_VARIANT_ID = variantInput.value;
  }

  document.addEventListener("on:variant:change", function (event) {
    if (event.detail?.variant?.id) {
      window.PDP_SELECTED_VARIANT_ID = event.detail.variant.id;
    }
  });

  const modal = document.getElementById("at-productModal");

  // --- Initial sticky total & ensure buttons have handlers ---
  // Run once at init to show base price and set button disabled state
  (function initStickyAndButtons() {
    const totalPriceEl = document.getElementById('sticky-total-price');
    const addBtn = document.getElementById('add-selected-to-cart');
    const skipBtn = document.getElementById('skip-to-cart-btn');

    // Determine base price: modal.dataset.variantPrice may be populated on open; try to fetch a sensible initial value
    const priceEl = document.querySelector('.at-modal-product-wrapper [data-product-price]');
    const basePrice = parseInt((modal && modal.dataset && modal.dataset.variantPrice) || (priceEl?.dataset?.productPrice) || window.PDP_SELECTED_VARIANT_PRICE || 0, 10) || 0;

    if (totalPriceEl) {
      // set dataset for later usage and display formatted base price
      totalPriceEl.dataset.basePrice = basePrice;
      totalPriceEl.innerHTML = 'Total Price: <span style="color:#00A207">' + formatMoney(basePrice) + '</span>';
    }

    if (addBtn) {
      // start disabled until user selects kit items
      addBtn.disabled = true;
      // defensive: mark as bound so we don't double attach trivial handler
      if (!addBtn._attachModuleBound) {
        addBtn._attachModuleBound = true;
        // don't override main handler - this is a noop placeholder to guard against missing handlers
        addBtn.addEventListener('click', function () {});
      }
    }

    if (skipBtn) {
      // Defensive: only mark as bound here. Main click handler attached once later (minimal diff)
      if (!skipBtn._attachModuleBound) {
        skipBtn._attachModuleBound = true;
      }
    }
  })();

  // ARROW SCROLL
  document.querySelectorAll(".carousel-arrow").forEach(button => {
    button.addEventListener("click", function (event) {
      event.stopPropagation();
      event.preventDefault();
      const direction = button.dataset.direction;
      const track = button.closest(".carousel-wrapper")?.querySelector(".carousel-track");
      if (!track) return;
      const scrollAmount = 300;
      track.scrollBy({ left: direction === 'left' ? -scrollAmount : scrollAmount, behavior: 'smooth' });
    });
  });

  // ARROW VISIBILITY
  function updateArrowVisibility(wrapper) {
    const track = wrapper.querySelector(".carousel-track");
    const leftArrow = wrapper.querySelector(".left-arrow");
    const rightArrow = wrapper.querySelector(".right-arrow");
    if (!track || !leftArrow || !rightArrow) return;
    
    const scrollLeft = track.scrollLeft;
    const maxScrollLeft = track.scrollWidth - track.clientWidth;
    leftArrow.style.display = scrollLeft > 0 ? 'flex' : 'none';
    rightArrow.style.display = scrollLeft < maxScrollLeft - 1 ? 'flex' : 'none';
  }

  // INIT ARROWS
  const resizeObservers = new Map();
  const eventListeners = new Map();
  
  document.querySelectorAll(".carousel-wrapper").forEach(wrapper => {
    const track = wrapper.querySelector(".carousel-track");
    if (!track) return;
    
    updateArrowVisibility(wrapper);
    
    const scrollHandler = () => updateArrowVisibility(wrapper);
    track.addEventListener("scroll", scrollHandler);
    eventListeners.set(`scroll-${wrapper.id || wrapper.dataset.id || Math.random()}`, scrollHandler);
    
    // Store ResizeObserver for cleanup
    const observer = new ResizeObserver(() => updateArrowVisibility(wrapper));
    observer.observe(track);
    resizeObservers.set(wrapper, observer);
  });

  // PILL ACTIVATION ON SCROLL
  document.querySelectorAll(".carousel-track").forEach((track) => {
    track.addEventListener("scroll", function () {
      const wrapper = track.closest(".carousel-wrapper");
      const pillsContainer = wrapper?.querySelector(".carousel-pills");
      if (!pillsContainer) return;
      
      const pills = pillsContainer.querySelectorAll(".carousel-pill");
      const children = Array.from(track.children).filter(el => el.classList.contains("at-modal-product-kit-wrapper"));
      if (children.length === 0) return;
      
      const scrollLeft = track.scrollLeft;
      const firstChild = children[0];
      const marginRight = parseInt(getComputedStyle(firstChild).marginRight || 0);
      const childWidth = firstChild.offsetWidth + marginRight;
      
      if (childWidth === 0) return; // Prevent division by zero
      
      const index = Math.round(scrollLeft / childWidth);
      pills.forEach(p => p.classList.remove("active"));
      if (pills[index]) pills[index].classList.add("active");
    });
  });

  // INIT FIRST PILL ACTIVE
  document.querySelectorAll(".carousel-wrapper").forEach(wrapper => {
    const pillsContainer = wrapper.querySelector(".carousel-pills");
    if (!pillsContainer) return;
    const pills = pillsContainer.querySelectorAll(".carousel-pill");
    pills.forEach(p => p.classList.remove("active"));
    if (pills[0]) pills[0].classList.add("active");
  });

  // OPEN MODAL
  const openBtn = document.querySelector(".select-items-btn");
  const closeBtn = document.querySelector(".close-btn");

  // Helper to safely get PDP values
  function getPDPValues() {
    const variantInput = document.querySelector('input[name="id"]');
    const qtyInput = document.querySelector('input[name="quantity"]');
    const priceEl = document.querySelector('.at-modal-product-wrapper [data-product-price]');
    
    return {
      variantId: variantInput?.value,
      quantity: parseInt(qtyInput?.value || "1", 10),
      price: parseInt(priceEl?.dataset.productPrice || "0", 10)
    };
  }

  if (openBtn && modal) {
    openBtn.addEventListener("click", function () {
      // ✅ Fetch latest PDP values on modal open
      const { variantId, quantity, price } = getPDPValues();

      window.PDP_SELECTED_VARIANT_ID = variantId;
      window.PDP_SELECTED_VARIANT_PRICE = price;
      window.PDP_SELECTED_QTY = quantity;

      modal.dataset.variantId = variantId;
      modal.dataset.variantPrice = price;
      modal.dataset.selectedQty = quantity;

      modal.style.display = "block";
      document.body.style.overflow = "hidden";

      modalOpenedWithoutAction = true; // Track modal open
      hasExplicitlyAddedToCart = false; // Reset on new open
      isModuleClosing = false; // Reset module closing state

      // ✅ Use requestAnimationFrame instead of setTimeout for better perf
      requestAnimationFrame(() => {
        if (typeof updateStickyBar === 'function') updateStickyBar();
      });
    });
  }

  // Helper to show add to cart notification
  function showAddToCartNotification() {
    const notificationTemplate = document.getElementById("AddedNotification");
    if (!notificationTemplate) return;
    
    const toastEl = notificationTemplate.content.cloneNode(true);
    const notification = toastEl.querySelector("added-notification");
    if (notification) {
      notification.dataset.productTitle = window.customProductData?.product?.title || "Product";
      document.body.appendChild(notification);
    }
  }


  // Enhanced Sentry logging with context
  function logSentryError(error, context = {}) {
    if (window.CultStoreSentry) {
      window.CultStoreSentry.captureCheckoutError(error, {
        stage: context.stage || 'unknown',
        method: context.method || 'unknown',
        errorMessage: error.message,
        variantId: context.variantId || null,
        itemsCount: context.itemsCount || 0,
        responseStatus: context.responseStatus || null,
        pageUrl: window.location.href,
        userAgent: navigator.userAgent,
        timestamp: Date.now()
      });
    }
  }

  // Helper to add main product to cart
  async function addMainProductToCart(variantId, quantity) {
    if (!variantId) return false;

    // Prevent duplicate in-flight adds
    if (window.__attachModulePendingAdd) return false;
    window.__attachModulePendingAdd = true;

    try {
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), NETWORK_TIMEOUT_MS); // 10s timeout
      
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: quantity }]
        }),
        signal: controller.signal
      });

      clearTimeout(timeoutId);

      if (response.ok) {
        hasExplicitlyAddedToCart = true;
        showAddToCartNotification();
        return true;
      } else {
        const errorData = await response.json().catch(() => ({}));
        showErrorToast(errorData.description || 'Failed to add item to cart');
        logSentryError(new Error(errorData.description || 'Cart add failed'), {
          stage: 'cart_add_main_product',
          method: 'addMainProductToCart',
          variantId,
          responseStatus: response.status,
          itemsCount: 1
        });
        return false;
      }
    } catch (error) {
      if (error.name !== 'AbortError') {
        logSentryError(error, {
          stage: 'cart_add_main_product',
          method: 'addMainProductToCart',
          variantId,
          itemsCount: 1
        });
        showErrorToast('Network error. Please try again.');
      }
      return false;
    } finally {
      window.__attachModulePendingAdd = false;
    }
  }

  if (closeBtn && modal) {
    closeBtn.addEventListener("click", function () {
      closeModalCleanly();
    });
  }

  // ESCAPE KEY HANDLER - Single global handler
  const escapeHandler = function(e) {
    if (e.key === 'Escape' && modal?.style.display === 'block' && !isModuleClosing) {
      e.preventDefault();
      closeModalCleanly();
    }
  };
  document.addEventListener('keydown', escapeHandler);
  eventListeners.set('escape-key', escapeHandler);

  // CLOSE MODAL BY CLICKING BACKDROP
  if (modal) {
    const backdropHandler = async function (e) {
      // Only close if clicked directly on modal backdrop
      if (e.target === modal && !isModuleClosing) {
        const currentPDP = getPDPValues();
        
        if (!currentPDP.variantId) {
          closeModalCleanly();
          return;
        }

        // Use exact same logic as skip-to-cart-btn
        const success = await addMainProductToCart(currentPDP.variantId, currentPDP.quantity);
        if (success) {
          closeModalCleanly();
        }
        // Modal stays open on failure (consistent with skip-to-cart)
      }
    };
    modal.addEventListener("click", backdropHandler);
    eventListeners.set('modal-backdrop', backdropHandler);
  }

  // Centralized modal close logic with module-level race guard
  async function closeModalCleanly() {
    if (!modal || isModuleClosing) return;
    
    isModuleClosing = true; // Module-level race condition guard
    
    modal.classList.add('closing');
    setTimeout(() => {
      modal.style.display = "none";
      modal.classList.remove('closing');
      document.body.style.overflow = "";
      modalOpenedWithoutAction = false;
      isModuleClosing = false; // Reset only after complete close
    }, MODAL_CLOSE_ANIMATION_MS);
  }

  // HIDE VARIANT ERROR ON CHANGE
  document.querySelectorAll('.at-variant-selector input[type="radio"]').forEach(radio => {
    radio.addEventListener('change', function () {
      const wrapper = radio.closest('.at-variant-selector-wrapper');
      const error = wrapper?.querySelector('.variant-error-message');
      if (error) error.style.display = 'none';
    });
  });

  // PRICE FORMATTER
  function formatMoney(paisa) {
    return '₹' + (paisa / 100).toLocaleString('en-IN', { maximumFractionDigits: 0 });
  }

  // UPDATE STICKY PRICE & BUTTON
  function updateStickyBar() {
    const totalPriceEl = document.getElementById('sticky-total-price');
    const btn = document.getElementById('add-selected-to-cart');

    // ✅ Failsafe guard
    if (!totalPriceEl || !btn || !modal) {
      return;
    }

    // Prefer modal dataset (set on modal open). Fallback to any data attr on the sticky el or global.
    const basePrice = parseInt(modal.dataset.variantPrice || totalPriceEl.dataset?.basePrice || window.PDP_SELECTED_VARIANT_PRICE || 0, 10) || 0;

    // gather checked kit items
    const checkedBoxes = Array.from(document.querySelectorAll('.kit-product-checkbox')).filter(cb => cb.checked);
    const selectedCount = checkedBoxes.length;

    // compute total
    let total = basePrice;
    checkedBoxes.forEach(cb => {
      const price = parseInt(cb.getAttribute('data-product-price'), 10) || 0;
      total += price;
    });

    totalPriceEl.innerHTML = 'Total Price: <span style="color:#00A207">' + formatMoney(total) + '</span>';
    // enable Add-selected button only when at least one kit item is checked
    btn.disabled = (selectedCount === 0);
  }

  document.querySelectorAll('.kit-product-checkbox').forEach(cb => {
    cb.addEventListener('change', updateStickyBar);
  });

  // HIDE EMPTY VARIANT SELECTORS
  const variantSelectorWrappers = document.querySelectorAll('.at-variant-selector-wrapper');

  variantSelectorWrappers.forEach(wrapper => {
    const labels = wrapper.querySelectorAll('label.opt-label');
    const nonEmptyLabels = Array.from(labels).filter(label => label.textContent.trim() !== "");

    // ✅ Hide wrapper if zero or only one valid label
    if (nonEmptyLabels.length <= 1) {
      wrapper.classList.add("hidden");
    }
  });

  // Ensure checkboxes start unchecked and only auto-select single variant when user checks ---
  document.querySelectorAll('.at-modal-product-kit-wrapper').forEach(wrapper => {
    const checkbox = wrapper.querySelector('.kit-product-checkbox');
    const radios = wrapper.querySelectorAll('input[type="radio"]');

    if (!checkbox) return;

    // Force initial unchecked state (defensive)
    checkbox.checked = false;

    // Handler: when user checks the kit item, auto-select single variant if applicable, then update sticky bar
    const onCheckboxChange = function () {
      if (checkbox.checked) {
        if (radios && radios.length === 1) {
          radios[0].checked = true;
          radios[0].dispatchEvent(new Event('change', { bubbles: true }));
        }
        const variantWrapper = wrapper.querySelector('.at-variant-selector-wrapper');
        const errorMessage = variantWrapper?.querySelector('.variant-error-message');
        if (errorMessage) errorMessage.style.display = 'none';
      }
      updateStickyBar();
    };

    // Remove any previous duplicate listener (defensive) then add
    checkbox.removeEventListener('change', onCheckboxChange);
    checkbox.addEventListener('change', onCheckboxChange);
  });

  // Also ensure all kit checkboxes trigger updateStickyBar (idempotent)
  document.querySelectorAll('.kit-product-checkbox').forEach(cb => {
    cb.removeEventListener('change', updateStickyBar);
    cb.addEventListener('change', updateStickyBar);
  });

  // ADD TO CART
  const addSelectedBtn = document.getElementById("add-selected-to-cart");
  if (addSelectedBtn) {
    const addToCartHandler = async function () {
      if (isModuleClosing) return; // Race condition guard
      if (window.__attachModulePendingAdd) return;
      window.__attachModulePendingAdd = true;

      try {
        const items = [];
        const checkboxes = document.querySelectorAll(".kit-product-checkbox:checked");
        let missingVariant = false;
        let firstMissingElement = null;

        const currentPDP = getPDPValues();

        // Always try to push the PDP main variant first
        if (currentPDP.variantId) {
          items.push({ id: currentPDP.variantId, quantity: currentPDP.quantity });
        }

        // Loop through checked kit items and validate variant selection
        checkboxes.forEach((checkbox) => {
          const wrapper = checkbox.closest(".at-modal-product-kit-wrapper");
          const variantWrapper = wrapper?.querySelector(".at-variant-selector-wrapper");
          const selectedRadio = variantWrapper?.querySelector('input[type="radio"]:checked');
          const errorMessage = variantWrapper?.querySelector('.variant-error-message');

          if (selectedRadio?.value) {
            items.push({ id: selectedRadio.value, quantity: 1 });
            if (errorMessage) errorMessage.style.display = "none";
          } else {
            if (errorMessage) errorMessage.style.display = "block";
            if (!missingVariant) {
              missingVariant = true;
              firstMissingElement = wrapper;
            }
          }
        });

        // Scroll to the first item with missing variant
        if (missingVariant && firstMissingElement) {
          firstMissingElement.scrollIntoView({ behavior: "smooth", block: "center" });
          return;
        }

        try {
          // ✅ If only main product is selected, use helper function
          if (checkboxes.length === 0 && currentPDP.variantId) {
            const success = await addMainProductToCart(currentPDP.variantId, currentPDP.quantity);
            if (success) {
              closeModalCleanly();
            }
            return; // stop execution
          }

          // ✅ Normal bundle flow: main product + checked items with valid variants
          const controller = new AbortController();
          const timeoutId = setTimeout(() => controller.abort(), NETWORK_TIMEOUT_MS);
          
          const response = await fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ items }),
            signal: controller.signal
          });
          
          clearTimeout(timeoutId);

          if (response.ok) {
            hasExplicitlyAddedToCart = true;
            closeModalCleanly();

            showAddToCartNotification();
          } else {
            const errorData = await response.json().catch(() => ({}));
            showErrorToast(errorData.description || 'Failed to add items to cart');
            logSentryError(new Error(errorData.description || 'Bundle cart add failed'), {
              stage: 'cart_add_bundle',
              method: 'add_selected_to_cart',
              variantId: currentPDP.variantId,
              itemsCount: items.length,
              responseStatus: response.status
            });
          }
        } catch (error) {
          if (error.name !== 'AbortError') {
            logSentryError(error, {
              stage: 'cart_add_bundle',
              method: 'add_selected_to_cart',
              variantId: currentPDP.variantId,
              itemsCount: items.length
            });
            showErrorToast('Network error. Please try again.');
          }
        }
      } finally {
        window.__attachModulePendingAdd = false;
      }
    };
    addSelectedBtn.addEventListener("click", addToCartHandler);
    eventListeners.set('add-to-cart', addToCartHandler);
  }

  // SKIP TO CART - EXACT SAME LOGIC NOW USED BY BACKDROP
  const skipBtn = document.getElementById("skip-to-cart-btn");
  if (skipBtn) {
    const skipHandler = async function (e) {
      if (e && typeof e.stopPropagation === 'function') e.stopPropagation();
      const currentPDP = getPDPValues();
      
      if (!currentPDP.variantId) {
        showErrorToast('Please select a product variant first.');
        return;
      }

      const success = await addMainProductToCart(currentPDP.variantId, currentPDP.quantity);
      if (success) {
        closeModalCleanly();
      }
    };
    skipBtn.addEventListener("click", skipHandler);
    eventListeners.set('skip-to-cart', skipHandler);
  }

  // Enhanced cleanup function - called on page unload
  function cleanupAttachModule() {
    resizeObservers.forEach(observer => observer.disconnect());
    resizeObservers.clear();
    
    eventListeners.forEach((handler, key) => {
      if (typeof handler === 'function') {
        // Try to remove from common targets
        [document, modal, window].forEach(target => {
          if ((target && key.includes('key')) || key.includes('backdrop') || key.includes('scroll')) {
            const eventType = key.split('-')[0];
            target.removeEventListener(eventType, handler);
          }
        });
      }
    });
    eventListeners.clear();
    
    isModuleClosing = false;
    hasExplicitlyAddedToCart = false;
    modalOpenedWithoutAction = false;
  }

  // Expose cleanup and auto-call on page unload
  window.cleanupAttachModule = cleanupAttachModule;
  
  // Auto-cleanup on page unload/pagehide
  window.addEventListener('beforeunload', cleanupAttachModule);
  window.addEventListener('pagehide', cleanupAttachModule);

  isModuleInitialized = true;
});
